import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { getSearchListData } from '../../services/apps.service';

const Channels = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
  defaultSelectFirst,
  showNoneOption,
  allOption,
  disableCloseOnSelect,
  channelOption,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setValue(selectedValue);
  }, [defaultValue]);

  useEffect(() => {
    getSearchListData()
      .then((res) => {
        const channelData = res?.data || [];
        if (allOption) {
          channelData.unshift({ id: 'all', title: 'All Channels', code: null });
        }
        if (showNoneOption) {
          channelData.unshift({ id: null, title: 'None', code: null });
        }
        if (channelData && channelData.length === 1) {
          setValue(channelData[0]);
        }
        setOptions(channelData || []);
        if (defaultSelectFirst && res?.data?.length > 0) {
          setValue(res?.data?.[0]);
          onChange(res?.data?.[0]);
        }
        setLoading(false);
      })
      .catch(() => {
        // upon error, show loading only
      });
  }, []);

  useEffect(() => {
    if (channelOption.isAddAll) {
      setValue(options);
      onChange(options);
    } else if (channelOption.isRemoveAll) {
      setValue([]);
      onChange([]);
    }
  }, [channelOption]);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) =>
        (option?.code ? `${option?.code} - ` : '') + option.title
      }
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disableCloseOnSelect={disableCloseOnSelect}
      disabled={disabled}
      loading={loading}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      ListboxProps={{
        style: {
          maxHeight: `${Math.min(options.length * 48, 300)}px`,
          overflow: 'auto',
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
      disableClearable={showNoneOption || allOption}
    />
  );
};

Channels.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  defaultSelectFirst: PropTypes.bool,
  showNoneOption: PropTypes.bool,
  allOption: PropTypes.bool,
  disableCloseOnSelect: PropTypes.bool,
  channelOption: PropTypes.objectOf,
};
Channels.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
  defaultSelectFirst: false,
  showNoneOption: false,
  allOption: false,
  disableCloseOnSelect: false,
  channelOption: {},
};

export default Channels;
